import customStyle from "../custom.module.css";

const twitterIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="35"
    height="35"
    viewBox="0 0 35 35"
    fill="none"
  >
    <circle cx="17.5" cy="17.3984" r="17" fill="black" />
    <path
      d="M18.7093 16.4667L22.7747 11.9902H21.2741L18.0357 15.5725L15.1578 11.9902H11.3169L16.0978 17.9854L11.7555 22.8084H13.2087L16.7707 18.8796L19.9345 22.8084H23.6805L18.7093 16.4667ZM20.3201 21.6168L13.6181 13.1361H14.7303L21.4323 21.6168H20.3201Z"
      fill="white"
    />
  </svg>
);

const facebookIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="35"
    height="35"
    viewBox="0 0 35 35"
    fill="none"
  >
    <circle cx="17.5" cy="17.3984" r="17" fill="black" />
    <path
      d="M22.2557 18.1222L22.7767 14.9083H19.5202V12.82C19.5202 11.9412 19.9735 11.0822 21.4324 11.0822H22.9122V8.34222C22.042 8.20893 21.1667 8.13487 20.2862 8.125C17.6029 8.125 15.847 9.6653 15.847 12.4546V14.9083H12.8667V18.1271H15.847V25.9027H19.515V18.1271H22.2504L22.2557 18.1222Z"
      fill="white"
    />
  </svg>
);

const youtubeIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="35"
    height="35"
    viewBox="0 0 35 35"
    fill="none"
  >
    <circle cx="17.5" cy="17.3984" r="17" fill="black" />
    <path
      d="M26.5491 21.9454C26.3323 22.7579 25.6916 23.3977 24.8792 23.6152C23.4067 24.0098 17.4996 24.0098 17.4996 24.0098C17.4996 24.0098 11.5925 24.0098 10.1201 23.6152C9.30764 23.3977 8.66692 22.7579 8.45013 21.9454C8.05518 20.4718 8.05518 17.3987 8.05518 17.3987C8.05518 17.3987 8.05518 14.3256 8.45013 12.8519C8.66692 12.0394 9.30764 11.3996 10.1201 11.1821C11.5936 10.7875 17.4996 10.7875 17.4996 10.7875C17.4996 10.7875 23.4067 10.7875 24.8792 11.1821C25.6916 11.3996 26.3323 12.0394 26.5491 12.8519C26.9441 14.3245 26.9441 17.3987 26.9441 17.3987C26.9441 17.3987 26.9441 20.4718 26.5491 21.9454ZM15.5678 14.6081V20.1892L20.5047 17.3987L15.5678 14.6081Z"
      fill="white"
    />
  </svg>
);

const rssIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="35"
    height="35"
    viewBox="0 0 35 35"
    fill="none"
  >
    <circle cx="17.5" cy="17.3984" r="17" fill="black" />
    <path
      d="M11.4581 23.6303C11.9223 24.0945 12.475 24.3266 13.116 24.3266C13.7571 24.3266 14.3097 24.0945 14.7739 23.6303C15.2382 23.1661 15.4703 22.6134 15.4703 21.9724C15.4703 21.3313 15.2382 20.7787 14.7739 20.3145C14.3097 19.8502 13.7571 19.6181 13.116 19.6181C12.475 19.6181 11.9223 19.8502 11.4581 20.3145C10.9939 20.7787 10.7618 21.3313 10.7618 21.9724C10.7618 22.6134 10.9939 23.1661 11.4581 23.6303ZM18.9519 23.6303L21.7703 23.5971C21.7703 22.2929 21.5214 21.0108 21.0236 19.7508C20.5258 18.4907 19.7689 17.3523 18.7529 16.3355C17.737 15.3186 16.5957 14.5641 15.329 14.0721C14.0624 13.58 12.7721 13.3397 11.4581 13.3512L11.4581 16.1365C12.4308 16.1365 13.3758 16.3189 14.2931 16.6836C15.2105 17.0484 16.034 17.5955 16.7634 18.325C17.4929 19.0544 18.04 19.8779 18.4048 20.7952C18.7695 21.7126 18.9519 22.6576 18.9519 23.6303ZM24.5888 23.6303L27.3741 23.6303C27.3962 21.5745 27.0204 19.5739 26.2467 17.6286C25.473 15.6833 24.3014 13.9259 22.7319 12.3565C21.1624 10.787 19.4051 9.61536 17.4598 8.84167C15.5145 8.06798 13.5139 7.69218 11.4581 7.71429L11.4581 10.4996C13.1602 10.4996 14.8124 10.8201 16.4146 11.4612C18.0168 12.1022 19.4594 13.0638 20.7424 14.346C22.0254 15.6281 22.9868 17.0705 23.6266 18.6731C24.2663 20.2758 24.587 21.9282 24.5888 23.6303Z"
      fill="white"
    />
  </svg>
);

const tiktokIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="35"
    height="35"
    viewBox="0 0 35 35"
    fill="none"
  >
    <circle cx="17.5" cy="17.3984" r="17" fill="black" />
    <path
      d="M17.4864 9.68663C18.4081 9.67188 19.3221 9.67925 20.2399 9.67188C20.2668 10.7266 20.7085 11.7335 21.4727 12.4895C22.2984 13.2013 23.3506 13.6291 24.4567 13.6992V16.4246C23.4351 16.4025 22.429 16.1775 21.4996 15.7682C21.104 15.5875 20.7238 15.3772 20.359 15.1412C20.3513 17.1143 20.3667 19.0911 20.3436 21.0568C20.2899 22.012 19.9596 22.934 19.395 23.7195C18.4465 25.0361 16.9026 25.8438 15.2321 25.8918C14.2259 25.936 13.2235 25.6926 12.3594 25.1947C10.9155 24.3723 9.96304 22.9414 9.79022 21.3334C9.77486 20.9941 9.76718 20.6585 9.78254 20.3266C10.0706 17.531 12.6667 15.4879 15.5815 15.7645C15.6967 15.7755 15.812 15.7903 15.9272 15.8087C15.9425 16.8082 15.9003 17.8113 15.9003 18.8108C14.6406 18.3867 13.2619 19.021 12.8203 20.2307C12.8203 20.2344 12.8203 20.238 12.8165 20.2417C12.7051 20.5958 12.6744 20.9646 12.7166 21.3297C12.9048 22.484 13.9647 23.3175 15.1821 23.2696C15.9809 23.2475 16.7145 22.8381 17.1331 22.1816C17.2905 21.9714 17.3904 21.7243 17.4211 21.4661C17.4902 20.2565 17.4633 19.0505 17.471 17.8408C17.4787 15.1154 17.4633 12.3973 17.4864 9.67925V9.68663Z"
      fill="white"
    />
  </svg>
);

const telegramIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="35"
    height="35"
    viewBox="0 0 35 35"
    fill="none"
  >
    <circle cx="17.5" cy="17.3984" r="17" fill="black" />
    <path
      d="M23.0631 10.5397C23.0631 10.5397 24.8392 9.84712 24.6912 11.5291C24.6419 12.2217 24.1979 14.6457 23.8525 17.2676L22.6684 25.0343C22.6684 25.0343 22.5697 26.172 21.6817 26.3699C20.7936 26.5678 19.4615 25.6774 19.2148 25.4795C19.0174 25.3311 15.5145 23.1049 14.2811 22.0166C13.9357 21.7198 13.541 21.1262 14.3304 20.4336L19.5108 15.4867C20.1029 14.893 20.6949 13.5079 18.228 15.1898L11.3208 19.8894C11.3208 19.8894 10.5314 20.3841 9.05136 19.9389L5.84442 18.9495C5.84442 18.9495 4.66033 18.2075 6.68315 17.4654C11.6169 15.1403 17.6854 12.7658 23.0631 10.5397Z"
      fill="white"
    />
  </svg>
);

const forumIcon = (
  <span className={customStyle["forumIcon"]}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="35"
      height="35"
      viewBox="0 0 35 35"
      fill="none"
    >
      <path
        d="M19.3498 1.03813C19.6952 1.10597 20.2511 1.22707 20.5809 1.3179C21.9133 1.68681 23.3868 2.33268 24.6095 2.99762C33.5272 7.85121 38.0748 20.1054 31.266 28.6151C24.3497 37.2598 11.2002 35.0749 4.69204 27.103C-1.29154 19.7735 -1.1443 8.23469 7.4319 2.99762C7.84842 2.74308 8.44577 2.42351 8.88692 2.21382C9.03136 2.14486 9.20939 2.04394 9.3348 1.98956C10.3991 1.52814 11.8821 1.1127 13.0275 0.925438C13.6153 0.829566 14.2961 0.732573 14.8739 0.701176C16.2488 0.626609 17.9967 0.771258 19.3498 1.03701V1.03813ZM28.2109 24.1304C34.2287 18.1196 30.3708 8.34682 23.1528 5.37984C12.3428 0.936651 3.67257 12.3179 10.464 21.719C14.4948 27.2986 23.0145 29.3209 28.2109 24.1309V24.1304Z"
        fill="#8EC440"
      />
      <path
        d="M19.7299 7.82978C23.8117 7.46984 27.9949 10.7486 28.3011 14.8974C28.8508 22.3378 19.8363 24.2099 15.6028 18.8141C12.3378 14.6524 14.1668 8.32036 19.7299 7.82978Z"
        fill="#8EC440"
      />
    </svg>
  </span>
);

export {
  facebookIcon,
  forumIcon,
  rssIcon,
  telegramIcon,
  tiktokIcon,
  twitterIcon,
  youtubeIcon,
};
